import { ChangeEvent, FocusEvent, forwardRef } from 'react';
import MaskedInput from 'react-text-mask';

export const InputMask = forwardRef(
  (
    {
      onChange,
      mask,
      onFocus,
      onBlur,
      ...other
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any
    : any,
    _ref,
  ) => {
    const placeholderChar = '\u2000';

    const handleFocus = (event: FocusEvent<HTMLInputElement>) => {
      const { value } = event.target;
      const reverseValue = value.split('').reverse().join('');

      event.target.value = reverseValue
        .slice(reverseValue.search(/\d/), reverseValue.length)
        .split('')
        .reverse()
        .join('');

      onFocus?.();
    };

    const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;

      onChange({
        ...event,
        target: {
          name: other.name,
          value: value || null,
        },
      });
    };

    return (
      <MaskedInput
        {...other}
        showMask
        mask={mask}
        placeholderChar={placeholderChar}
        guide={false}
        onChange={onInputChange}
        onFocus={handleFocus}
        onBlur={onBlur}
      />
    );
  },
);
